import { render, staticRenderFns } from "./wardTwilioSetUp.vue?vue&type=template&id=c1ed23fa&"
import script from "./wardTwilioSetUp.vue?vue&type=script&lang=js&"
export * from "./wardTwilioSetUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports